import { create } from 'zustand'

type OfflineBannerState = {
  pageDataUpdatedAt: number | null
  setPageDataUpdatedAt: (timestamp: number | null) => void
}

export const useOfflineBannerStore = create<OfflineBannerState>(set => ({
  pageDataUpdatedAt: null,
  setPageDataUpdatedAt: timestamp => set({ pageDataUpdatedAt: timestamp }),
}))
